module.exports = __webpack_public_path__ + "img/undTooth10.0455e510.png";